<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      appMargin
      marginB="8"
    >
      <div fxFlex="grow" class="sub-value">Certificate of Incorporation</div>
      <div fxFlex class="right-aligned">
        <span class="sub-label">mandatory</span>
      </div>
    </div>

    <div class="ui form" appMargin marginB="8">
      <div class="field" [ngClass]="displayFieldCss('referenceNo')">
        <label>Document Name </label>
        <input
          formControlName="referenceNo"
          type="text"
          placeholder="Document Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('referenceNo')"
          errorMsg="Please company name"
        >
        </app-field-error-display>
      </div>
    </div>
    <div
      class="ui segment section"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div fxFlex>
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1"
            y="1"
            width="62"
            height="62"
            rx="5"
            stroke="#999999"
            stroke-width="2"
            stroke-dasharray="4 4"
          />
        </svg>
      </div>
      <div fxFlex="grow"><strong class="text">Upload Picture</strong></div>
      <div fxFlex>
        <button class="ui button">Browse</button>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending"
    (click)="save()"
    autofocus
  >
    Save
  </button>
</div>
